import { createAction, props } from '@ngrx/store';
import {
  ICounterModel,
  IEventDetail,
  IGeoLocationModel,
  IGetEventsDetailsResponse,
  IGetPoolMatrixRequest,
  IGetPoolMatrixResponse,
  IGetPoolsTotalsRequest,
  IGetPoolsTotalsResponse,
  IGetRCNReplayVideosByFiltersRequest,
  IGetRCNReplayVideoLinkRequest,
  IGetRaceAllOddsMatrixesRequest,
  IGetRaceVideoRequest,
  IGetEloRatingsRequest,
  IGetEloRatingsResponse,
  IDataProduct,
  IGetWillPaysResponse,
  IPusher,
  IPusherDataURC,
  IRCNGetLinkResponse,
  IRace,
  IToteLinkResponse,
  IToteOddsMatrixCallResponse,
  IToteResultResponse,
  IToteWageringGetCountersResponse,
  TError
} from '@amwager/util-ts';
import { SortEventsPipe } from '@amwager/util';
import { IBet, IBetStackTicket, IBetTicket, IPersonalStatistic, ITicketSlim } from './wager.models';



/**
 * State
 */
export const initWagerState = createAction(
  '[Wager] Init State',
  props<{
    sourceInitiator: string
  }>()
);
export const clearWagerState = createAction(
  '[Wager] Clear State',
  props<{
    sourceInitiator: string
  }>()
);

export const loadWagerStateSuccess = createAction(
  '[Wager] Load Wager State Success'
);
export const loadWagerStateFailure = createAction(
  '[Wager] Load Wager State Failure',
  props<{ error: TError }>()
);


/**
 * GET Request
 */
export const getRunnersAPI = createAction(
  '[Wager_API] Get all runner',
  props<{
    runnerPrefix: string
  }>()
);

export const getEquibaseChangesAPI = createAction(
  '[Wager_API] Get all equibase changes',
  props<{
    equibaseEventId: string,
    raceDate?: string
  }>()
);

export const getAllEventsAPI = createAction(
  '[Wager_API] Get all current events'
);

export const getAllEventsByDateAPI = createAction(
  '[Wager_API] Get of all events by date',
  props<{
    requestedDateStr: string
  }>()
);

export const getAllTracksForGeoAPI = createAction(
  '[Wager_API] Get a list of all tracks'
);

export const getEventDetailLiteAPI = createAction(
  '[Wager_API] Gets event, race and pool data trimmed down for non-wagering',
  props<{
    eventId: string
  }>()
);

export const getAllEventsNameAndIdAPI = createAction(
  '[Wager_API] Gets a list of all event names and ids',
  props<{
    sourceInitiator: string
  }>()
);

export const getEventsDetailsAPI = createAction(
  '[Wager_API] Get an object representing event details for all of todays events',
  props<{
    sourceInitiator: string,
    runId?: string,
    isAutoUpdate?: boolean,
    replay?: boolean
  }>()
);

export const getCompressedEventsDetailsAPI = createAction(
  '[Wager_API] Get a compressed event details for all of todays events',
  props<{
    callOrigin: 0|1|2,
    runId?: string
  }>()
);

export const getEventDetailAPI = createAction(
  '[Wager_API] Get event detail',
  props<{
    sourceInitiator: string,
    eventId: string,
    runId: string,
    callOrigin: 0|1|2,
    replay?: boolean
  }>()
);

export const getRaceAPI = createAction(
  '[Wager_API] Get detailed race',
  props<{
    sourceInitiator: string,
    raceId: number,
    runId: string,
    eventId: string
  }>()
);

export const getRaceResultAPI = createAction(
  '[Wager_API] Get result race',
  props<{
    raceId: number,
    runId: string,
    eventId: string,
    getPoolTotals?: boolean,
    sourceInitiator: string,
    replay?: boolean
  }>()
);

// bet section
export const getCountersAPI = createAction(
  '[Wager_API] get counters',
  props<{
    sourceInitiator: string,
    runId: string
   }>()
);

export const getBetsAPI = createAction(
  '[Wager_API] get bets',
  props<{
    sourceInitiator: string,
    bet: IBet,
    status: 'close' | 'saved' | 'active',
    replay?: boolean
   }>()
);

export const submitSavedBetAPI = createAction(
  '[Wager_API] submit saved bet',
  props<{
    ticket: ITicketSlim
   }>()
);

export const removeSavedBetAPI = createAction(
  '[Wager_API] remove saved bet',
  props<{
    ticket: ITicketSlim
   }>()
);

export const cancelBetAPI = createAction(
  '[Wager_API] cancel bet',
  props<{
    ticket: ITicketSlim
   }>()
);

export const saveBetAPI = createAction(
  '[Wager_API] save bet amount',
  props<{
    betTicket: IBetTicket
    // betStackTicket: IBetStackTicket
   }>()
);

export const betNowAPI = createAction(
  '[Wager_API] bet amount',
  props<{
    betTicket: IBetTicket
   }>()
);

export const getPoolMatrixAPI = createAction(
  '[Wager_API] Get Pool Matrix API',
  props<{
    sourceInitiator: string,
    requests: IGetPoolMatrixRequest,
    fromPusher?: boolean,
  }>()
);

export const getPoolsTotalsAPI = createAction(
  '[Wager_API] Get Pools Totals API',
  props<{
    sourceInitiator: string,
    requests: IGetPoolsTotalsRequest,
    fromPusher?: boolean,
  }>()
);

export const getWillPaysAPI = createAction(
  '[Wager_API] Get Will Pays API',
  props<{
    sourceInitiator: string,
    requests: {
      raceId: number,
      eventId: string,
      runId: string,
      replay?: boolean
    }
  }>()
);

export const getRaceAllOddsMatrixesAPI = createAction(
  '[Wager_API] Get Race All Odds Matrixes API',
  props<{
    sourceInitiator: string,
    requests: IGetRaceAllOddsMatrixesRequest,
    pool: 'WIN' | 'TRU',
    fromPusher?: boolean,
  }>()
);

export const getEloRatingsAPI = createAction(
  '[Wager_API] Get Elo Ratings API',
  props<{
    sourceInitiator: string,
    requests: IGetEloRatingsRequest
  }>()
);

export const getDataProgramsAPI = createAction(
  '[Wager_API] Get Data Programs API',
  props<{
    sourceInitiator: string,
    date: string
  }>()
);

export const downloadDataProgramAPI = createAction(
  '[Wager_API] Download Data Program API',
  props<{
    sourceInitiator: string,
    raceDate: string,
    productId: string
  }>()
);

export const getReplaysAPI = createAction(
  '[Wager_API] Get replays',
  props<{
    sourceInitiator: string,
    requests: IGetRCNReplayVideosByFiltersRequest
  }>()
);

export const getEventRaceVideoLiveAPI = createAction(
  '[Wager_API] Get Event Race Video Live API',
  props<{
    sourceInitiator: string,
    request: IGetRaceVideoRequest,
    typeVideo: 'default' | 'IGB'
  }>()
);

export const getEventRaceVideoReplayAPI = createAction(
  '[Wager_API] Get Event Race Video Replay API',
  props<{
    sourceInitiator: string,
    request: IGetRCNReplayVideoLinkRequest
  }>()
);



/**
 * GET Response SUCCESS
 */
export const getRunnersAPISuccess = createAction(
  '[Wager_API] Successfully get all runner',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getEquibaseChangesAPISuccess = createAction(
  '[Wager_API] Successfully get all equibase changes',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getAllEventsAPISuccess = createAction(
  '[Wager_API] Successfully get all current events',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    raceMorningMatrix?: object,
    toteResponse: IToteLinkResponse
   }>()
);

export const getAllEventsByDateAPISuccess = createAction(
  '[Wager_API] Successfully get of all events by date',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getAllTracksForGeoAPISuccess = createAction(
  '[Wager_API] Successfully get a list of all tracks',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getEventDetailLiteAPISuccess = createAction(
  '[Wager_API] Successfully gets event, race and pool data trimmed down for non-wagering',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getAllEventsNameAndIdAPISuccess = createAction(
  '[Wager_API] Successfully gets a list of all event names and ids',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getEventsDetailsAPISuccess = createAction(
  '[Wager_API] Successfully get an object representing event details for all of todays events',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: IGetEventsDetailsResponse[] }>()
);

export const getCompressedEventsDetailsAPISuccess = createAction(
  '[Wager_API] Successfully get a compressed event details for all of todays events',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getEventDetailAPISuccess = createAction(
  '[Wager_API] Successfully get event details',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    eventId: string,
    successResponse: any,
    raceId?: number,
 }>()
);

export const getRaceAPISuccess = createAction(
  '[Wager_API] Successfully get detailed race',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getRaceResultAPISuccess = createAction(
  '[Wager_API] Successfully get result race',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    successResponse: any,
    eventId: string,
    previousEventsResult?: any
  }>()
);

// bet section
export const getCountersAPISuccess = createAction(
  '[Wager_API] Successfully get counters',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{
    successResponse: any,
  }>()
);

export const getBetsAPISuccess = createAction(
  '[Wager_API] Successfully fetch bets',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{
    successResponse: any,
    status: 'close' | 'saved' | 'active'
  }>()
);

export const submitSavedBetAPISuccess = createAction(
  '[Wager_API] Successfully submit saved bet',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{
    // ticket: ITicketSlim,
    ticket: any,
    successResponse: any,
  }>()
);

export const removeSavedBetAPISuccess = createAction(
  '[Wager_API] Successfully remove saved bet',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{
    // ticket: ITicketSlim,
    ticket: any,
    successResponse: any,
  }>()
);

export const cancelBetAPISuccess = createAction(
  '[Wager_API] Successfully cancel bet',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{
    ticket: ITicketSlim,
    successResponse: any,
  }>()
);

export const saveBetAPISuccess = createAction(
  '[Wager_API] Successfully save bet',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{
    successResponse: any,
  }>()
);

export const betNowAPISuccess = createAction(
  '[Wager_API] Successfully bet amount',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{
    successResponse: any,
  }>()
);

export const getPoolMatrixAPISuccess = createAction(
  '[Wager_API] Successfully Get Pool Matrix',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    eventId: string,
    raceId: number,
    poolId: string,
    replayMatrix?: boolean,
    successResponse: IGetPoolMatrixResponse
  }>()
);

export const getPoolMatrixReplayAPISuccess = createAction(
  '[Wager_API] Successfully Get Pool Matrix Replay',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    successResponse: IGetPoolMatrixResponse
  }>()
);

export const getPoolsTotalsAPISuccess = createAction(
  '[Wager_API] Successfully Get Pools Totals',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    eventId: string,
    raceId: number,
    replay?: boolean,
    successResponse: IGetPoolsTotalsResponse
  }>()
);

export const getWillPaysAPISuccess = createAction(
  '[Wager_API] Successfully Get Will Pays API',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    eventId: string,
    raceId: number,
    replay?: boolean,
    successResponse: IGetWillPaysResponse
  }>()
);

export const getRaceAllOddsMatrixesAPISuccess = createAction(
  '[Wager_API] Successfully Get Race All Odds Matrixes API',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    pool: 'WIN' | 'TRU',
    eventId: string,
    raceId: number,
    replay?: boolean,
    successResponse: IToteOddsMatrixCallResponse
  }>()
);

export const getEloRatingsAPISuccess = createAction(
  '[Wager_API] Successfully Get Elo Ratings API',
  props<{
    eventId: string,
    raceId: number,
    successResponse: IGetEloRatingsResponse
  }>()
);

export const getDataProgramsAPISuccess = createAction(
  '[Wager_API] Successfully Get Data Programs API',
  props<{
    date: string,
    successResponse: IDataProduct[]
  }>()
);

export const downloadDataProgramAPISuccess = createAction(
  '[Wager_API] Successfully Download Data Program API',
  props<{
    productId: string,
    successResponse: string
  }>()
);

export const getReplaysAPISuccess = createAction(
  '[Wager_API] Successfully get replays',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getEventRaceVideoLiveAPISuccess = createAction(
  '[Wager_API] Get Event Race Video Live API Success',
  props<{
    successResponse: IRCNGetLinkResponse,
    eventId: string
  }>()
);

export const getEventRaceVideoReplayAPISuccess = createAction(
  '[Wager_API] Get Event Race Video Replay API Success',
  props<{
    successResponse: IRCNGetLinkResponse,
    eventId: string
  }>()
);

export const setEventRaceVideoReplay = createAction(
  '[Wager_API] Set Event Race Video Replay',
  props<{
    successResponse: any,
    eventId: string
  }>()
);

export const setReplayEventsDetails = createAction(
  '[Wager_API] Successfully set replay events details',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    successResponse: any,
 }>()
);



/**
 * GET Response ERROR
 */
export const getRunnersAPIFailed = createAction(
  '[Wager_API] Failed to get all runner',
  props<{ errorResponse: TError }>()
);

export const getEquibaseChangesAPIFailed = createAction(
  '[Wager_API] Failed get all equibase changes',
  props<{ errorResponse: TError }>()
);

export const getAllEventsAPIFailed = createAction(
  '[Wager_API] Failed get all current events',
  props<{ errorResponse: TError }>()
);

export const getAllEventsByDateAPIFailed = createAction(
  '[Wager_API] Failed get of all events by date',
  props<{ errorResponse: TError }>()
);

export const getAllTracksForGeoAPIFailed = createAction(
  '[Wager_API] Failed get a list of all tracks',
  props<{ errorResponse: TError }>()
);

export const getEventDetailLiteAPIFailed = createAction(
  '[Wager_API] Failed gets event, race and pool data trimmed down for non-wagering',
  props<{ errorResponse: TError }>()
);

export const getAllEventsNameAndIdAPIFailed = createAction(
  '[Wager_API] Failed gets a list of all event names and ids',
  props<{ errorResponse: TError }>()
);

export const getEventsDetailsAPIFailed = createAction(
  '[Wager_API] Failed get an object representing event details for all of todays events',
  props<{ errorResponse: TError }>()
);

export const getCompressedEventsDetailsAPIFailed = createAction(
  '[Wager_API] Failed get a compressed event details for all of todays events',
  props<{ errorResponse: TError }>()
);

export const getEventDetailAPIFailed = createAction(
  '[Wager_API] Failed get event details',
  props<{ errorResponse: TError }>()
);

export const getRaceAPIFailed = createAction(
  '[Wager_API] Failed get detailed race',
  props<{ errorResponse: TError }>()
);

export const getRaceResultAPIFailed = createAction(
  '[Wager_API] Failed get result race',
  props<{ errorResponse: TError }>()
);

// bet section
export const getCountersAPIFailed = createAction(
  '[Wager_API] Failed to get counters',
  props<{ errorResponse: TError }>()
);

export const getBetsAPIFailed = createAction(
  '[Wager_API] Failed to fetch bets',
  props<{ errorResponse: TError }>()
);

export const submitSavedBetAPIFailed = createAction(
  '[Wager_API] Failed to submit saved bet',
  props<{ errorResponse: TError }>()
);

export const removeSavedBetAPIFailed = createAction(
  '[Wager_API] Failed to remove saved bet',
  props<{ errorResponse: TError }>()
);

export const cancelBetAPIFailed = createAction(
  '[Wager_API] Failed to cancel bet',
  props<{ errorResponse: TError }>()
);

export const saveBetAPIFailed = createAction(
  '[Wager_API] Failed to save bet',
  props<{ errorResponse: TError }>()
);

export const betNowAPIFailed = createAction(
  '[Wager_API] Failed to bet amount',
  props<{ errorResponse: TError }>()
);

export const getPoolMatrixAPIFailed = createAction(
  '[Wager_API] Failed to Get Pool Matrix',
  props<{
    poolId: string,
    errorResponse: TError
  }>()
);

export const getPoolsTotalsAPIFailed = createAction(
  '[Wager_API] Failed to Get Pools Totals',
  props<{ errorResponse: TError }>()
);

export const getWillPaysAPIFailed = createAction(
  '[Wager_API] Failed to Get Will Pays API',
  props<{ errorResponse: TError }>()
);

export const getRaceAllOddsMatrixesAPIFailed = createAction(
  '[Wager_API] Failed to Get Race All Odds Matrixes API',
  props<{
    pool: 'WIN' | 'TRU',
    errorResponse: TError
  }>()
);

export const getEloRatingsAPIFailed = createAction(
  '[Wager_API] Failed to Get Elo Ratings API',
  props<{
    eventId: string,
    raceId: number,
    errorResponse: TError
  }>()
);

export const getDataProgramsAPIFailed = createAction(
  '[Wager_API] Failed to Get Data Programs API',
  props<{
    date: string,
    errorResponse: TError
  }>()
);

export const downloadDataProgramAPIFailed = createAction(
  '[Wager_API] Failed to Download Data Program API',
  props<{
    productId: string,
    errorResponse: TError
  }>()
);

export const getReplaysAPIFailed = createAction(
  '[Wager_API] Failed to get replays',
  props<{ errorResponse: TError }>()
);

export const getEventRaceVideoLiveAPIFailed = createAction(
  '[Wager_API] Get Event Race Video Live API Failed',
  props<{
    errorResponse: TError
  }>()
);

export const getEventRaceVideoReplayAPIFailed = createAction(
  '[Wager_API] Get Event Race Video Replay API Failed',
  props<{
    errorResponse: TError
  }>()
);

export const setReplayEventDetailFailed = createAction(
  '[Wager_API] Failed set replay event detail',
  props<{ errorResponse: TError }>()
);

export const setReplayEventResultFailed = createAction(
  '[Wager_API] Failed set replay event result',
  props<{ errorResponse: TError }>()
);

export const setReplayEventsDetailsAPIFailed = createAction(
  '[Wager_API] Failed set replay events details',
  props<{ errorResponse: TError }>()
);



/**
 * Properties
 */
export const setError = createAction(
  '[Wager] Set an error',
  props<{ error: TError }>()
);

// export const setCurrentRace = createAction(
//   '[Wager] Set the current race to event detail',
//   props<{
//     sourceInitiator: string
//     currentRace: IRace,
//     id: string
//   }>()
// );

export const selectedEventTrack = createAction(
  '[Wager] Set selected event track',
  props<{
    sourceInitiator: string
    selectedEventTrack: IGetEventsDetailsResponse
  }>()
);

export const selectedRace = createAction(
  '[Wager] Set selected race',
  props<{
    sourceInitiator: string
    selectedRace: IRace,
    eventId: string,
    runId: string
  }>()
);

// export const setRaceResult = createAction(
//   '[Wager] Set race result',
//   props<{
//     sourceInitiator: string
//     result: IToteResultResponse
//   }>()
// );


export const updateRace = createAction(
  '[Wager] Update race data from event track',
  props<{
    sourceInitiator: string
    data: IPusherDataURC
  }>()
);

export const updateRaceFinal = createAction(
  '[Wager] Update race data Final from event track',
  props<{
    sourceInitiator: string,
    data: IPusher
  }>()
);

export const updateRaceCancelled = createAction(
  '[Wager] Update race data Cancelled from event track',
  props<{
    sourceInitiator: string,
    data: IPusher
  }>()
);

export const updateRaceClosed = createAction(
  '[Wager] Update race data Closed from event track',
  props<{
    sourceInitiator: string,
    data: IPusher
  }>()
);

export const updateRaceOpen = createAction(
  '[Wager] Update race data Open from event track',
  props<{
    sourceInitiator: string,
    data: IPusher
  }>()
);

export const updateRacePost = createAction(
  '[Wager] Update race data Post from event track',
  props<{
    sourceInitiator: string,
    data: IPusher
  }>()
);

export const updateResultsPersonalStatistics = createAction(
  '[Wager] Update race results with personal statistics',
  props<{
    sourceInitiator: string
    countersAPISuccessData?: IToteWageringGetCountersResponse
  }>()
);

export const setTicket = createAction(
  '[Wager] Set ticket',
  props<{
    bet: IBetTicket
  }>()
);

export const setGeoLocation = createAction(
  '[Wager] Set geolocation',
  props<{
    sourceInitiator: string,
    location: IGeoLocationModel
  }>()
);

export const setIsShowBetPreview = createAction(
  '[Common] Set bet preview status, if hide or show',
  props<{ isShowBetPreview: boolean; }>()
);

export const updateRaceMatrix = createAction(
  '[Wager] Update Race Matrix',
  props<{
    sourceInitiator: string,
    matrix: any
  }>()
);

export const updateRacePoolsTotals = createAction(
  '[Wager] Update Race Pools Totals',
  props<{
    sourceInitiator: string,
    poolsTotals: any
  }>()
);

export const triggerMatrixModal = createAction(
  '[Wager] Trigger Matrix Modal',
  props<{
    sourceInitiator: string
  }>()
);

export const toUpdateGeneralEvents = createAction(
  '[Wager] To Update General Events',
  props<{
    sourceInitiator: string
  }>()
);

export const setEventLiveVideo = createAction(
  '[Wager] Set live event video',
  props<{
    liveEventVideo: any
  }>()
);

export const setSelectedReplayInfo = createAction(
  '[Wager] Set reply info',
  props<{
    track: string,
    date: string,
    breed: string,
    race: string,
    runId?: string | boolean,
    eventId?: string,
    poolId?: string,
    showOdds?: boolean
  }>()
);

export const setLatestFinishedEvent = createAction(
  '[Wager] Set latest finished event',
  props<{
    latestEvent: IGetEventsDetailsResponse,
    raceId?: number
  }>()
);

export const clearRaceAllOddsMatrixes = createAction(
  '[Wager] Clear Race All Odds Matrixes',
  props<{
    sourceInitiator: string
  }>()
);

export const clearEloRatings = createAction(
  '[Wager] Clear Elo Ratings',
  props<{
    sourceInitiator: string
  }>()
);

export const clearDataProgramDownload = createAction(
  '[Wager] Clear Data Program Download',
  props<{
    sourceInitiator: string
  }>()
);

export const clearSelectedRaceMatrix = createAction(
  '[Wager] Clear Selected Race Matrix',
  props<{
    sourceInitiator: string
  }>()
);

export const clearSelectedRacePoolsTotals = createAction(
  '[Wager] Clear Selected Race Pools Totals',
  props<{
    sourceInitiator: string
  }>()
);

export const clearSelectedRaceWillPays = createAction(
  '[Wager] Clear Selected Race Will Pays',
  props<{
    sourceInitiator: string
  }>()
);

export const clearReplayMatrix = createAction(
  '[Wager] Clear Replay Matrix Slices',
  props<{
    sourceInitiator: string
  }>()
);

export const setDefaultEvent = createAction(
  '[Wager] Set default event',
  props<{
    isSetDefaultEvent: boolean
  }>()
);

export const setEventResultToShow = createAction(
  '[Wager] Set event result to show',
  props<{
    eventId?: string,
    race?: string,
    runId?: string
    eventDate?: string
    runners?: any
  }>()
);

export const setEventReplayVideo = createAction(
  '[Wager] Set event replay video',
  props<{
    video?: string
  }>()
);

export const setPreviousEventResult = createAction(
  '[Wager] Set previous event result',
  props<{
    successResponse: any
  }>()
);

export const setReplayEventResult = createAction(
  '[Wager] Set replay event result',
  props<{
    successResponse: any,
    previousEventsResult?: any
  }>()
);

export const setReplayEventDetail = createAction(
  '[Wager] Set replay event detail',
  props<{
    successResponse: any
  }>()
);

export const setAllEventsByDate = createAction(
  '[Wager] Set all events by date',
  props<{
    successResponse: any
  }>()
);

export const setReplayBets = createAction(
  '[Wager] Set replay bets',
  props<{
    successResponse: any
  }>()
);

export const setReplayMatrix = createAction(
  '[Wager] Set replay matrix',
  props<{
    event: any,
    race: any,
    eventId?: string,
    runId?: string
  }>()
);

export const setRefreshWager = createAction(
  '[Wager] Set refresh wager',
  props<{
    trigger: boolean
  }>()
);
